import { ActionIcon, Text } from "@mantine/core";
import { useMantineTextColorIndex } from "hooks/useMantineTextColor";
import "./styles.css";

interface ActionIconSelectItem<T> {
  icon: JSX.Element;
  value: T;
}

export const ActionIconSelect = <T extends string>({
  items,
  label,
  onItemClick,
  value: selectedValue,
}: {
  items: ActionIconSelectItem<T>[];
  label: string;
  onItemClick: (value: T) => void;
  value: T;
}) => {
  const textColor = useMantineTextColorIndex();

  return (
    <div className="trkbk-context-menu sub-menu-item-action-icon-select">
      <>
        <Text
          className="label"
          sx={(_, u) => ({
            [u.dark]: {
              color: "inherit",
            },
            [u.light]: {
              color: "#495057",
            },
          })}
        >
          {label}
        </Text>
        {items.map(({ icon, value }) => {
          const isSelected = value === selectedValue;

          return (
            <ActionIcon
              className="action-icon"
              key={value}
              onClick={() => {
                onItemClick(value);
              }}
              size={28}
              variant={isSelected ? "filled" : "transparent"}
              c={isSelected ? "white" : textColor}
              sx={(theme, u) => ({
                "&:hover": {
                  [u.dark]: {
                    backgroundColor: isSelected
                      ? theme.primaryColor[7]
                      : theme.colors.dark[4],
                  },
                  [u.light]: {
                    backgroundColor: isSelected
                      ? theme.primaryColor[8]
                      : theme.colors.gray[1],
                  },
                },
              })}
            >
              <div className="icon">{icon}</div>
            </ActionIcon>
          );
        })}
      </>
    </div>
  );
};
